import React from 'react';
import { Card } from 'components/ui/card';
import { cn } from 'lib/utils';

const AuthPageLayout = ({ children, className }) => (
  <div
    className={cn(
      'flex min-h-[calc(100dvh-75px)] w-full items-center justify-center bg-[#f6f8f7] px-4 py-8 font-[Inter,sans-serif] min-[521px]:min-h-[calc(100dvh-94px)] lg:min-h-screen max-[375px]:px-0',
      className
    )}
  >
    {children}
  </div>
);

const AuthCard = ({ children, className }) => (
  <Card
    className={cn(
      'relative w-full rounded-[9px] border-[#dce3de] bg-white p-[30px] shadow-[0_2px_4px_rgba(30,54,35,0.03)] max-[520px]:p-[22px] max-[375px]:p-[7px]',
      className
    )}
  >
    {children}
  </Card>
);

export { AuthCard, AuthPageLayout };
